import { z } from 'zod';
export const vendorSchema = z.object({
    order: z.number(),
    state: z.string().optional(),
    category: z.string(),
    contact: z.string().optional(),
    company: z.string().optional(),
    phoneOffice: z.string().optional(),
    phoneOfficeCountry: z.string().optional(),
    phoneOfficeExt: z.number().optional(),
    phoneMobile: z.string().optional(),
    phoneMobileCountry: z.string().optional(),
    phoneMobileExt: z.number().optional(),
    additionalInfo: z.string().optional(),
    email: z.string().optional(),
    website: z.string().optional(),
    license: z.string().optional(),
});
